module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assignment-item",
    on: {
      "click": _vm.input
    }
  }, [_c('field', {
    ref: "input",
    staticClass: "no-margin assignment-input",
    attrs: {
      "type": "checkbox",
      "value": _vm.assigned,
      "collection": [{
        value: true
      }],
      "label": "empty",
      "name": _vm.item.id.toString(),
      "params": {
        'no_i18n': true
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "assignment-label"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15eac0bf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/AssignmentModalElement.vue
// module id = 1821
// module chunks = 0